module.exports = function(app) {
	app.run(['Service','storage','sessionData', function (Service, storage, sessionData) {
		return new Service({

			name: 'employeesSummary',
			group: 'eprsvc',
			url: '/eprsvc/x-services/secure/employees/v1/umi',
			cache: false,

			fetch: function(umi) {
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				return this.post(umi);
			},

			save: function(data, pay) {
				console.log("InUpdated")
                if(sessionData && sessionData.clientNumber && sessionData.clientNumber !== undefined){
                    this.headers['ClientNumber']  = sessionData.clientNumber;
                }
				this.url = '/eprsvc/x-services/secure/employees/v1/subscriberSSN';
				if(window.location.href.indexOf('/find/review')!== -1){
					this.url += '?transactionType=EDIT';
				}
				else if (window.location.href.indexOf('/add/review-submit')!== -1){
					if(storage.get('ReinstateValue') === 'true'){
                        this.url += '?transactionType=REINSTATE';
					}else {
                        this.url += '?transactionType=ADD';
					}

				}
				else if(window.location.href.indexOf('/manage-employees/cancel-coverage')!== -1) {
                    this.url += '?transactionType=CANCEL';
				}
				return this.put(pay);
			}
		});
	}]);
	app.run(['Service', function (Service) {
		return new Service({

			name: 'employeesSummaryBySSN',
			group: 'eprsvc',
			url: '/eprsvc/x-services/secure/employees/v1/ssn/:ssn',
			cache: false,
			fetch: function() {
				return this.get();
			}
		});
	}]);
};
